export function compoundStates(tikz, statesArray) {
  for (var k = 0; k < statesArray.length; k++) {
    if (statesArray[k].statesRef != "") {
      var stRef = "(" + statesArray[k].statesRef + ")";
      var stState = "(" + statesArray[k].state + ")";
      const regex = new RegExp(`\\(${stRef}\\)`, "g");
      tikz = tikz.replace(regex, stState);
    }
  }
  return tikz;
}
